import { withTrailingSlash } from 'ufo'
import { indexedRoutes } from '~~/constants/indexedRoutes'

/**
 * Whether a locale-prefixed path (e.g. `/de-de/faq/`) is listed in
 * indexedRoutes. Query strings are not part of the match; SeoHelper noindexes
 * those separately.
 */
export const isIndexedRoutePath = (path: string, locale: string): boolean => {
  const localePrefix = `/${locale}`
  const pathWithoutLocale =
    path === localePrefix || path.startsWith(`${localePrefix}/`)
      ? path.slice(localePrefix.length)
      : path

  const normalizedPath = withTrailingSlash(pathWithoutLocale || '/')

  return indexedRoutes.some((route) => route.path === normalizedPath)
}

// Widgets and the booking embed are iframed on partner sites: keep the
// standalone URL out of search, but let Google index the content as part of
// the page that embeds it.
const EMBEDDABLE_PATH_REGEX = /^\/[a-z]{2}-[a-z]{2}\/(widgets|embedded)\//

/**
 * Robots content for pages on the blank layout (checkout, payment, order
 * success, rebook, review, auth callback, widgets, embeds). None of them is
 * meant to be found through search.
 */
export const getBlankLayoutRobotsContent = (path: string): string =>
  EMBEDDABLE_PATH_REGEX.test(withTrailingSlash(path))
    ? 'noindex, indexifembedded'
    : 'noindex, follow'
